import { FC, ReactChild, ReactElement } from 'react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { InPageNotification } from '@ebsco-ui/ebsco-ui';

import { PropsWithClassName } from '@app/constants';

export type NotificationProps = {
  variant: keyof typeof InPageNotification.VARIANT;
  header?: ReactChild;
  description?: ReactChild | (string | ReactElement)[];
  icon?: IconProp;
};

export const Notification: FC<PropsWithClassName<NotificationProps>> = ({
  className,
  variant,
  header,
  description,
  icon,
}) => (
  <InPageNotification className={className} variant={variant} icon={icon}>
    {(header as ReactChild) && (
      <InPageNotification.Header>{header}</InPageNotification.Header>
    )}
    {(description as ReactChild) && (
      <InPageNotification.Description>
        <span data-auto="notification-description">{description}</span>
      </InPageNotification.Description>
    )}
  </InPageNotification>
);
